import { useCallback, useEffect, useRef, useState } from 'react';

import { fetch_email_switch } from '../api';
import { mode_of_switch } from './logic';

// The mode a manual send runs in now (GET /email/switch). null until read; a failed read stays null
// (the badge hides, and the confirm step still shows the dry run's own mode).
const useSendMode = () => {
  const [mode, setMode] = useState(null);
  const seq = useRef(0);
  const reload = useCallback(() => {
    seq.current += 1;
    const mine = seq.current;
    // Started inside a promise so any failure (even a throw) only hides the badge.
    Promise.resolve()
      .then(() => fetch_email_switch())
      .then((d) => {
        if (mine === seq.current) setMode(mode_of_switch(d));
      })
      .catch(() => {
        if (mine === seq.current) setMode(null);
      });
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return { mode: mode ? mode.mode : null, reload };
};

export default useSendMode;
